import { render, staticRenderFns } from "./automations_duplicate_modal.vue?vue&type=template&id=7935bf9e&"
import script from "./automations_duplicate_modal.vue?vue&type=script&lang=js&"
export * from "./automations_duplicate_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports